import { render, staticRenderFns } from "./modalReferidosClientes.vue?vue&type=template&id=67e5fadc"
import script from "./modalReferidosClientes.vue?vue&type=script&lang=js"
export * from "./modalReferidosClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports